import React from 'react';
import Text from '../../../Text';
import Header from '../../../Header';
import LayoutColumn from '../LayoutColumn';
import Stack from '../../../Stack';

const AnnotatedSection = ({
  title,
  additionalTitleContent,
  description,
}) => (
  <LayoutColumn>
    <Stack vertical spacing="narrow">
      <Stack.Item>
        <Stack spacing="narrow" verticalAlignment={additionalTitleContent?.position}>
          <Stack.Item>
            <Header>
              {title}
            </Header>
          </Stack.Item>
          {additionalTitleContent && (
            <Stack.Item>
              {additionalTitleContent.content}
            </Stack.Item>
          )}
        </Stack>
      </Stack.Item>
      {description && (
        <Stack.Item>
          <Text>
            {description}
          </Text>
        </Stack.Item>
      )}
    </Stack>
  </LayoutColumn>
);

AnnotatedSection.defaultProps = {
  description: '',
  additionalTitleContent: null,
};

AnnotatedSection.displayName = 'Layout.AnnotatedSection';

export default AnnotatedSection;
